import axios from 'axios';
import { baseUrl } from "../common/siteSettings";
import heyapi from "../middleware/axiosInstance";

export const getAllStudents = async (state, token) => {
    console.log(state)
    try {
        const response = await heyapi.get(`/admin/student/filter?state=${state}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        console.log(response)
        return response;
    }
    catch (err) {
        console.log(err);
    }
}

//write function to get student details
export const getStudentDetails = async (studentid, token) => {
    try {
        const response = await heyapi.get(`/admin/student/details?id=${studentid}`, {    
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    }
    catch (err) {
        console.log(err);
    }
}

export const updateStudentState = async (studentid, state, token, reason) => {
    try {
        const data = {
            studentid: studentid, 
            status: state, 
            reason: reason
        }
        const response = await heyapi.patch(`/admin/student/updatestate`, 
            data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        //console.log(response.data)
        return response;
    }
    catch (err) {
        console.log(err);
    }
}

// Delete student
export const deleteStudent = async (studentid, token) => {  
    try {
        const response = await heyapi.delete(`/admin/student/${studentid}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    }
    catch (err) {
        console.log(err);
    }
}

// Get special students (with permissions)
export const getSpecialStudents = async (token) => {
    try {
        const response = await heyapi.get(`/admin/specialusers/filter`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    }
    catch (err) {
        console.log(err);
    }
}

// Update student permissions
export const updateStudentPermissions = async (studentid, permissions, token) => {
    try {
        const data = {
            studentid: studentid,
            permissions: permissions
        }
        const response = await heyapi.patch(`/admin/specialusers/updatepermissions`, 
            data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    }
    catch (err) {
        console.log(err);
    }
}